module.exports = __webpack_public_path__ + "img/222.7fec6e00.jpg";